import getWrappedUseMutation from "api/helpers/getWrappedUseMutation";

import apiClient from "../../../api-client";

const useUpdateLanguageLabelsTimeFormatsMutation = getWrappedUseMutation(apiClient.ItineraryBooklets.put);

export { useUpdateLanguageLabelsTimeFormatsMutation };
